import React, { useState, useRef, useEffect } from "react";
import "./trivia.css";
import Modal from "react-bootstrap/Modal";
import Correct from "./correct";
import Incorrect from "./incorrect";
import Win from "./win";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import Cookie from "js-cookie";

const TriviaCard = ({ title, number, data, length }) => {
  const [show, setShow] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState(Array(data.length).fill(null));
  const [selected, setSelected] = useState(null);
  const [message, setMessage] = useState("");
  const [answered, setAnswered] = useState(false);
  const [progress, setProgress] = useState(0);
  const [progressColor, setProgressColor] = useState("#265384");
  const [win, setWin] = useState(false);

  const audioRef = useRef(null);
  const backgroundMusicRef = useRef(null);

  useEffect(() => {
    if (show && !win) {
      initBackgroundMusic();
    } else {
      pauseBackgroundMusic();
    }
  }, [show, win]);

  const initBackgroundMusic = () => {
    backgroundMusicRef.current = new Audio("../../../../sounds/background.mp3");
    backgroundMusicRef.current.loop = true;
    backgroundMusicRef.current.volume = 0.3;
    backgroundMusicRef.current.play();
  };

  const pauseBackgroundMusic = () => {
    if (backgroundMusicRef.current) {
      backgroundMusicRef.current.pause();
    }
  };

  const handleClose = () => {
    setShow(false);
    setMessage("");
    window.location.reload();
    setWin(false);
  };
  const handleShow = () => {
    setShow(true);
    setCurrentQuestion(0);
    setProgress(0);
    setSelected(null);
    setAnswers(Array(data.length).fill(null));
  };

  const handleSelect = (responseIndex) => {
    setSelected(responseIndex);
    handleAnswer(responseIndex - 1);
  };

  const handleAnswer = async (responseIndex) => {
    try {
      const isCorrect =
        data[currentQuestion].responses[responseIndex].id_res ===
        data[currentQuestion].correct;
      const updatedAnswers = [...answers];
      updatedAnswers[currentQuestion] =
        data[currentQuestion].responses[responseIndex].id_res;
      setAnswers(updatedAnswers);
      setAnswered(true);
      if (isCorrect) {
        playCorrectSound();
        setMessage("Respuesta Correcta");
        setProgress(progress + 1);
        setProgressColor("#80D5E4");
        if (currentQuestion === data.length - 1) {
          const userData = jwtDecode(Cookie.get("token"));
          const userId = userData.userId;
          const apiUrl = process.env.REACT_APP_API_BASE_URL;
          await axios.post(
            `${apiUrl}/questions/`,
            {
              userId: userId,
              questionNumber: number,
              cardAssigned: number,
            },
            {
              headers: { "Content-Type": "application/json" },
              method: "POST",
            }
          );
          setMessage("Felicitaciones");
          setCurrentQuestion(currentQuestion + 1);
          playWin();
          setWin(true);
        }
      } else {
        playIncorrectSound();
        setMessage("Respuesta Incorrecta");
        setProgress(0);
      }
    } catch (error) {
      console.error("Error al guardar la respuesta:", error);
    }
  };

  const playCorrectSound = () => {
    audioRef.current.src = "../../../../sounds/correct.mp3";
    audioRef.current.volume = 0.3;
    audioRef.current.addEventListener("canplay", () => {
      audioRef.current.play();
    });
    audioRef.current.addEventListener("ended", () => {
      backgroundMusicRef.current.play();
    });
  };
  const playIncorrectSound = () => {
    audioRef.current.src = "../../../../sounds/error.mp3";
    audioRef.current.volume = 0.05;
    audioRef.current.addEventListener("canplay", () => {
      audioRef.current.play();
    });
    audioRef.current.addEventListener("ended", () => {
      backgroundMusicRef.current.play();
    });
  };
  const playWin = () => {
    audioRef.current.src = "../../../../sounds/success.mp3";
    audioRef.current.addEventListener("canplay", () => {
      audioRef.current.play();
    });
    audioRef.current.addEventListener("ended", () => {
      backgroundMusicRef.current.pause();
    });
  };

  const handleNextPage = () => {
    setCurrentQuestion(currentQuestion + 1);
    setSelected(null);
    setMessage("");
    setAnswered(false);
    console.log(currentQuestion + 1, "currenQuestion");
  };

  const handleReset = () => {
    setCurrentQuestion(0);
    setSelected(null);
    setMessage("");
    setAnswered(false);
  };

  const Response = () => {
    return (
      <>
        {message === "Respuesta Correcta" ? (
          <Correct message={message} handleNextPage={handleNextPage} />
        ) : (
          ""
        )}
        {message === "Respuesta Incorrecta" ? (
          <Incorrect message={message} handleReset={handleReset} />
        ) : (
          ""
        )}
        {message === "Felicitaciones" ? (
          <Win number={number} handleClose={handleClose} length={length} />
        ) : (
          ""
        )}
      </>
    );
  };

  const renderStars = () => {
    const stars = Array.from({ length: 3 }, (_, index) => {
      const starType =
        index === currentQuestion - 1
          ? "star-bg"
          : index < currentQuestion - 1
          ? "star-bg"
          : "star-grey";
      const starSize = index === 1 ? "45" : "35";
      return (
        <img
          key={index}
          src={`../../../../images/${starType}.png`}
          alt="estrella"
          width={`${starSize}`}
        />
      );
    });
    return stars;
  };

  return (
    <div className="trivia-card">
      <audio ref={audioRef} />
      <button className="button-modal" onClick={handleShow}>
        <span className="number">{number}</span>
      </button>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{"Figurita " + number}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="stars">{renderStars()}</div>
          {message === "Felicitaciones" ? (
            <Response className="check-button"></Response>
          ) : (
            data.map((question, index) => (
              <div
                key={question.id_ques}
                style={{
                  display: index === currentQuestion ? "block" : "none",
                }}
              >
                <p className="question">{question.question}</p>
                <div className="answers">
                  {question.responses.map((response, responseIndex) => (
                    <li
                      key={response.id_res}
                      className={`response ${
                        selected === responseIndex + 1
                          ? response.id_res === question.correct
                            ? "selected correct"
                            : "selected incorrect"
                          : ""
                      }`}
                      onClick={() => handleSelect(responseIndex + 1)}
                      style={{ pointerEvents: answered ? "none" : "auto" }}
                    >
                      {response.text}
                    </li>
                  ))}
                  <div style={{ marginTop: "20px" }}>
                    <div
                      style={{
                        width: `${(progress / 3) * 100}%`,
                        height: "8px",
                        marginTop: "-8px",
                        backgroundColor: progressColor,
                        transition: "width 0.5s ease-in-out",
                      }}
                    />
                  </div>
                  <Response className="check-button"></Response>
                </div>
              </div>
            ))
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default TriviaCard;
